import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'react-smooth-collapse';
import _isEmpty from 'lodash/isEmpty';

import { projectType, menuItemType } from 'types';
import MenuItem from 'components/Sidebar/components/MenuItem';
import LinkedMenuItem from 'components/Sidebar/components/LinkedMenuItem';
import SidebarSubmenu from './components/SidebarSubmenu';

export default class SidebarMenuItem extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    item: menuItemType.isRequired,
    currentProject: projectType.isRequired,
  };

  state = {
    isExpanded: true,
  };

  handleToggleCollapsible = () => {
    this.setState(prevState => ({
      isExpanded: !prevState.isExpanded,
    }));
  };

  hasChildren = item => !_isEmpty(item.groups);

  /* eslint-disable jsx-a11y/anchor-is-valid */
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disablejsx-a11y/no-static-element-interactions */
  /* eslint-disable jsx-a11y/anchor-is-valid */
  /* eslint-disable react/no-array-index-key */
  render() {
    const { item, currentProject, isOpen } = this.props;
    const hasChildren = this.hasChildren(item);
    const { isExpanded } = this.state;

    return this.hasChildren(item) ? (
      <React.Fragment>
        <MenuItem
          onClick={this.handleToggleCollapsible}
          isOpen={isOpen}
          isTop
          hasChildren={hasChildren}
          isExpanded={isExpanded}
          item={item}
        />

        <Collapsible expanded={isExpanded}>
          {item.groups.map((group, index) => (
            <SidebarSubmenu
              key={index}
              group={group}
              currentProject={currentProject}
              isOpen={isOpen}
            />
          ))}
        </Collapsible>
      </React.Fragment>
    ) : (
      <LinkedMenuItem currentProject={currentProject} item={item}>
        <MenuItem
          isOpen={isOpen}
          isTop
          hasChildren={hasChildren}
          isExpanded={isExpanded}
          item={item}
        />
      </LinkedMenuItem>
    );
  }
}
